import { gql } from '@apollo/client';

export type Response = boolean;

export default gql`
  mutation checkNotification($id: Int!) {
    checkNotification(input: { id: $id })
  }
`;
